import {
  CustomerContact,
  resolveCustomerContact,
} from "@/modules/common/utils/customer-contact";

/** Hidden contact details cannot tell us whether a real phone exists; the API decides. */
export function isStatusBlockedWithoutPhone(
  required?: boolean,
  contacts?: readonly CustomerContact[] | null,
  hidden = false,
) {
  if (!required || hidden || contacts == null) return false;
  return resolveCustomerContact(contacts).kind !== "phone";
}
